export function formatTime(seconds) {
    const days = String(Math.floor(seconds / 86400)).padStart(2, "0");
    const hrs = String(Math.floor((seconds % 86400) / 3600)).padStart(2, "0");
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return { days, hrs, mins, secs };
}

export function parsePrice(value) {
    if (value == null) return null;
    // The API returns currency-formatted strings (e.g. "R$832,00").
    // Strip non-numeric chars, then normalize the decimal separator.
    const stripped = String(value).replace(/[^\d,.]/g, '');
    const hasComma = stripped.includes(',');
    const normalized = hasComma
        ? stripped.replace(/\./g, '').replace(',', '.')
        : stripped;
    const numeric = parseFloat(normalized);
    return Number.isNaN(numeric) || numeric <= 0 ? null : numeric;
}

export function mapOfferToPromoBanner(offer) {
    const isValid =
        offer &&
        typeof offer === "object" &&
        !!offer.headerTitle &&
        !!offer.discountText &&
        !!offer.endTime;

    if (!isValid) return null;

    const colors = offer.colors || {};

    return {
        type: offer.type || "promo-banner",
        productName: offer.headerTitle,
        productHref: offer.redirectUrl || "",
        discountText: offer.discountText || "",
        coupon: offer.coupon || null,
        secondaryText: offer.secondaryText || "",
        endTime: offer.endTime || null,
        price: parsePrice(offer.price),
        specialPrice: parsePrice(offer.specialPrice),
        colors: {
            background: colors.background || "#ffffff",
            base: colors.base || "#15803d",
            closeIcon: colors.closeIcon || "#d0cfc4",
            primaryText: colors.primaryText || "#000000",
            secondaryText: colors.secondaryText || "#ffffff"
        },
    };
}

export function getSecondsUntilEndTime(endTime) {
    if (!endTime) return 0;

    const normalized = String(endTime).trim();
    // API may return "dd/mm/yyyy HH:mm:ss" (non-ISO) — parse manually before falling back to Date().
    const brazilianMatch = normalized.match(
        /^(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):(\d{2}):(\d{2})$/
    );

    let endDate;

    if (brazilianMatch) {
        const [, day, month, year, hours, minutes, seconds] = brazilianMatch;
        endDate = new Date(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hours),
            Number(minutes),
            Number(seconds)
        );
    } else {
        endDate = new Date(normalized.replace(" ", "T"));
    }

    const diff = endDate.getTime() - Date.now();

    if (Number.isNaN(diff) || diff <= 0) return 0;

    return Math.floor(diff / 1000);
}

export function getVisibleTimerSeconds(totalSeconds) {
    if (totalSeconds <= 0) return 0;
    return totalSeconds;
}
